module.exports = __webpack_public_path__ + "pc-top-assets/img/logo-white.c45e8d16.svg";